import {
  AssociationTeam,
  Group,
  Organization,
  SubTeam,
  TeamManager,
  TeamOpportunity,
} from "@entities";
import { TeamFieldConfig } from "../team-field-config";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations, Validators } from "remult";
import { TeamEntityConfig } from "./config";
import { TeamFilters } from "./filters";
import { TeamMethods } from "./methods";

@HyperEntity<Team>("team", TeamEntityConfig)
export class Team extends extender(TeamFilters, TeamMethods) {
  @Fields.id()
  id = "";

  @Relations.toMany(() => SubTeam, {
    field: "teamId",
    defaultIncluded: true,
  })
  subTeams: SubTeam[] = [];

  @Relations.toOne<Team, SubTeam>(() => SubTeam, {
    fields: {
      subTeamId: "id",
    },
  })
  parentTeam?: SubTeam;

  @Relations.toMany(() => TeamOpportunity, "teamId")
  opportunities: TeamOpportunity[] = [];

  @Relations.toMany(() => AssociationTeam, { field: "teamId" })
  associations: AssociationTeam[] = [];

  @Relations.toMany(() => Group, { field: "team" })
  groups: Group[] = [];

  @Fields.string<Team>({
    validate: Validators.required,
    caption: "שם הפרויקט",
    maxLength: 35,
  })
  name = "";

  @Fields.boolean({
    dbName: "is_main_organization_team",
    defaultValue: () => false,
  })
  isMainOrganizationTeam = false;

  @Fields.boolean({ dbName: "is_project", defaultValue: () => false })
  isProject = false;

  @Fields.string({
    dbName: "organization_id",
  })
  organizationId = "";

  @Relations.toOne<Team, Organization>(() => Organization, "organizationId")
  organization?: Organization;

  @Fields.string({ caption: "הערות" })
  comments = "";

  @Fields.string({
    dbName: "project_explanation",
    caption: "הסבר על הפרויקט",
  })
  projectExplanation = "";

  @Fields.string({
    dbName: "volunteer_description",
    caption: "תיאור למתנדבים",
  })
  volunteerDescription = "";

  @Relations.toMany(() => TeamManager, {
    field: "teamId",
    caption: "מנהלים",
  })
  managers?: TeamManager[];

  @Relations.toMany(() => TeamFieldConfig, "teamId")
  fieldConfigs: TeamFieldConfig[] = [];

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
